import axios from "axios";
import moment from "moment";
// import store from '../store';

function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  bankaccount() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/bankcashacc/allaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankacconly() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/bankcashacc/bankaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankfcy() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/bankcashacc/fcyaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankcashbook(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/bankcashbook${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankcashbookprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "tgl1", "tgl2"];
        let str = "?";
        if (obj.tabIndex || 0 === 0) {
          str += "view=" + encodeURIComponent("noDim");
        } else {
          str += "view=" + encodeURIComponent("withDim");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/cashflow/bankcashbookprint${str}`;
        const { data } = await axios.get(url);
        // console.log('data : ', data);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankcashbookexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/bankcashbookexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `bankcash_book_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },

  bankcashbookdetail(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/bankcashbookdetail${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankcashbookdetailprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "tgl1", "tgl2"];
        let str = "?";
        if (obj.tabIndex || 0 === 0) {
          str += "view=" + encodeURIComponent("noDim");
        } else {
          str += "view=" + encodeURIComponent("withDim");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/cashflow/bankcashbookdetailprint${str}`;
        const { data } = await axios.get(url);
        // console.log('data : ', data);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankcashbookdetailexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/bankcashbookdetailexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `bankcash_book_${obj.tgl2}_${moment().format("YYYYMMDD")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  cashflowthn(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/cashflowthn${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
        // resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowthnprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];

        let str = "?";
        if (obj.tabIndex === 0) {
          str += "view=" + encodeURIComponent("summary");
        } else {
          str += "view=" + encodeURIComponent("current");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/cashflow/cashflowthnprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowthnexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/cashflowthnexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `cashflow_yearly${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  cashflow_date(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/cashflowdate${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflow_dateprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];

        let str = "?";
        if (obj.tabIndex === 0) {
          str += "view=" + encodeURIComponent("summary");
        } else {
          str += "view=" + encodeURIComponent("current");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/cashflow/cashflowdateprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflow_dateexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/cashflowdateexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `cashflow_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  cashflowdim10(obj) {
    obj.modeGet = "view";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
          "DimLimit",
          "sortBy",
          "modeGet",
        ];

        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/cashflowdim10${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowdim10print(obj = {}) {
    obj.modeGet = "print";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
          "DimLimit",
          "sortBy",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/cashflow/cashflowdim10${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowdim10export(obj = {}) {
    obj.modeGet = "exportxls";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
          "DimLimit",
          "sortBy",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/cashflowdim10${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `cashflow_${obj.DimColInfo}_${obj.tgl2}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  cashflowgl(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "kodeak", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/cashflowgl${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowglprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "kodeak", "tgl1", "tgl2"];
        let str = "?";
        if ((obj.tabIndex || 1) === 1) {
          str += "view=" + encodeURIComponent("withDim");
        } else {
          str += "view=" + encodeURIComponent("noDim");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/cashflow/cashflowglprint${str}`;
        const { data } = await axios.get(url);
        // console.log('data : ', data);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowglexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "kodeak", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/cashflowglexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `gl_cashflow_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  cashflowtrx(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/cashflowtrx${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cashflowtrxexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/cashflowtrxexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `CashFlow_Trx_Detail_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  cfinvalidacc(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/cashflow/cfinvalidacc${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  cfinvalidaccexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/cashflow/cfinvalidaccexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Trx_invalid_CF_acc_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  changekodecash(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.put("/cashflow/changekodecash", obj);
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  clearkodecash(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.put("/cashflow/clearkodecash", obj);
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      let str = "";
      try {
        switch (obj.namatable) {
          case "buku":
            str = `?nomor=${encodeURIComponent(
              obj.nomor
            )}&tanggal=${encodeURIComponent(
              moment(obj.tanggal).format("YYYY-MM-DD")
            )}`;
            url = `/buku/printjv`;
            break;

          case "jurnal":
            errorHandler(
              Error("Transaski belum diposting di Accounting"),
              reject
            );
            break;

          default:
            str = "?key=" + encodeURIComponent(obj.trbankkey);
            if (obj.nomor.substr(1, 1) == "M") {
              url = `/tranbank/printreceivejv`;
            } else {
              url = `/tranbank/printpaymentjv`;
            }
            break;
        }
        url += str;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutcashflow(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // const { data } = await axios.get(`cashflow/layoutcashflow/${encodeURIComponent(obj.layout)}`);
        const { data } = await axios.get(`cashflowfmt/${encodeURIComponent(obj.layout)}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutcashflow_combo() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`cashflowfmt/combo`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutcashflowDel(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(`cashflowfmt/${encodeURIComponent(obj.layout)}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutcashflowSave(data) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post("cashflowfmt", data);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
